import { render, staticRenderFns } from "./FunnelData.vue?vue&type=template&id=472c49bf&scoped=true"
import script from "./FunnelData.vue?vue&type=script&lang=js"
export * from "./FunnelData.vue?vue&type=script&lang=js"
import style0 from "./FunnelData.vue?vue&type=style&index=0&id=472c49bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c49bf",
  null
  
)

export default component.exports